import {withFormik} from "formik";
import * as yup from "yup"
import httpClient from "../../../services/httpClient";
import {commentsApi} from "../../../constans/apiUrls";
import {ICommentData} from "../../../contracts/data/comment";
import InnerCommentForm from "../../../components/FormTemplates/comment/InnerCommentForm";


const commentFormValidationSchema = yup.object().shape({
    content: yup.string().required(' متن الزامی میباشد'),
})

interface ICommentFormProps {
    formType?: string,
}

const CommentForm = withFormik<ICommentFormProps, ICommentData>({
    mapPropsToValues: props => ({
        id: 0,
        like_count: 0,
        dislike_count: 0,
        user:'',
        video_product_title:'',
        content: '',
        answer: '',
        is_active: false,
        jalali_created_time: '',
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: commentFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        await httpClient().put(`${commentsApi.update}/${values.id}`, values)
            .then(response => {
                if(response.status === 200){
                    formikBag.setStatus({
                        ...formikBag.props,
                        result: response.data
                    })
                }
            })
            .catch(error => formikBag.setStatus({
                ...formikBag.props,
                result: error.response.data
            }))
    },
    displayName: 'CommentForm'
})(InnerCommentForm)

export default CommentForm